import Spline from "@splinetool/react-spline";
import { useSpline } from "../context/SplineContext";

export default function SplinePart({ className, splineRef, onSplineReady }) {
  const { setSplineData } = useSpline();

  const mobile = window.matchMedia("(max-width: 767px)").matches;

  function handleLoad(splineApp) {
    const object = splineApp.findObjectByName("MainGroup");
    const stateFirst = splineApp.findObjectByName("State1");
    const stateSecond = splineApp.findObjectByName("State2");
    const groupScale = splineApp.findObjectByName("group");

    if (object) {
      splineRef.current = object;

      if (typeof onSplineReady === "function") {
        onSplineReady(object, splineApp); // splineApp je prava instanca
      }

      setSplineData(object, splineApp, stateFirst, stateSecond, groupScale);

      if (groupScale && mobile) {
        groupScale.scale.x = 3;
        groupScale.scale.y = 3;
        groupScale.scale.z = 3;
      }
    } else {
      console.warn("MainObject NOT found");
    }
  }

  return (
    <div className={`spline-parent ${className}`}>
      <div className="spline-container">
        <div className="spline-wrapper-anim">
          <div className="spline-anim-wrapper homepage-anim-wrapper">
            <Spline
              onLoad={handleLoad}
              scene="https://prod.spline.design/PxHed8efiRLYIV9J/scene.splinecode"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
